import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading3XL,
  Heading4XL,
  HeadingLG,
  HeadingXL,
} from "../../../typography";

import { CarouselSection } from "./CarouselSection";
import { Link } from "react-router-dom";
import { RiveAnimation } from "../../components/ui/RiveAnimation";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";
import { challengeItems } from "../config/aboutConfig";

export const DarkCard = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[4em] tw-rounded-[4em] tw-bg-[#000862] tw-bg-[url('/landing_page_assets/backgrounds/bg3.jpg')] tw-bg-cover tw-bg-bottom tw-py-[5em] min840:tw-py-[7.5em]">
      <div className="tw-flex tw-w-full tw-max-w-[1448px] tw-items-center tw-justify-center tw-gap-x-[1em] min1040:tw-px-[4.75em]">
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-x-[4em] tw-gap-y-[1em] tw-px-[1.5em] min1040:tw-flex-row">
          <RiveAnimation
            src="/landing_page_assets/rive/10.riv"
            className="tw-aspect-square tw-h-full tw-w-full"
            fallbackSrc="/landing_page_assets/payor_network_page/img1.png"
            fallbackClassName="tw-h-full tw-w-full"
          />
          <div className="tw-flex tw-flex-col tw-justify-center tw-gap-[3em]">
            <div className="tw-flex tw-flex-col tw-gap-[1em]">
              <Heading3XL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
                We're focused on Durable Medical Equipment (DME).
              </Heading3XL>
              <Heading2XL className="tw-my-0 tw-text-white min440:tw-hidden">
                We're focused on Durable Medical Equipment (DME).
              </Heading2XL>
              <BodyXL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
                DME delivery is a part of healthcare that's forgotten until it
                goes wrong.
              </BodyXL>
              <BodyXL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
                Verse's AI-enabled ordering platform for DME solves these
                problems, ensuring patients & clinicians have a seamless
                experience every time.
              </BodyXL>
              <BodyLG className="tw-my-0 tw-text-white min440:tw-hidden">
                DME delivery is a part of healthcare that's forgotten until it
                goes wrong.
              </BodyLG>
              <BodyLG className="tw-my-0 tw-text-white min440:tw-hidden">
                Verse's AI-enabled ordering platform for DME solves these
                problems, ensuring patients & clinicians have a seamless
                experience every time.
              </BodyLG>
            </div>
            <StandardButton
              onClick={() => {}}
              style={"primary-blue"}
              className="tw-w-[13.75em] tw-rounded-full tw-px-[2em] tw-py-[1em] tw-text-[16px]"
            >
              <Link to="/contact" className="tw-no-underline">
                <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
                  Get a demo
                </BodyLGB>
                <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
                  Get a demo
                </BodyMDB>
              </Link>
            </StandardButton>
          </div>
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[2.75em] tw-px-[1.25em] min440:tw-gap-y-[4em]">
        <HeadingXL className="tw-my-0 tw-text-center tw-text-white">
          Challenges that exist in DME:
        </HeadingXL>
        <div className="tw-flex tw-flex-col tw-gap-[1.25em] tw-divide-x-0 tw-divide-y tw-divide-solid tw-divide-white tw-divide-opacity-15 min440:tw-flex-row min440:tw-divide-x min440:tw-divide-y-0">
          {challengeItems.map((item) => {
            return (
              <div
                key={item.src}
                className="tw-flex tw-flex-row tw-gap-x-[1.25em] tw-gap-y-[1.5em] tw-pt-[1.25em] min440:tw-basis-1/4 min440:tw-flex-col min440:tw-pl-[1.25em] min440:tw-pt-0"
              >
                <div className="tw-w-fit">
                  <img src={item.src} className={item.className} />
                </div>
                <div className="tw-flex tw-w-full tw-flex-col tw-gap-y-[0.25em]">
                  <HeadingXL className="tw-my-0 tw-text-white">
                    {item.title}
                  </HeadingXL>
                  <HeadingLG className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
                    {item.subtitle}
                  </HeadingLG>
                  <BodyLG className="tw-my-0 tw-text-white min440:tw-hidden">
                    {item.subtitle}
                  </BodyLG>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[4em]">
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-[1em]">
          <Heading4XL className="tw-my-0 tw-hidden tw-text-center tw-text-white min440:tw-flex">
            Our Company
          </Heading4XL>
          <Heading2XL className="tw-my-0 tw-text-center tw-text-white min440:tw-hidden">
            Our company
          </Heading2XL>
          <BodyXL className="tw-my-0 tw-hidden tw-text-center tw-text-white min440:tw-flex">
            We're a team of doers determined to change healthcare for the better
          </BodyXL>
          <BodyLG className="tw-my-0 tw-text-center tw-text-white min440:tw-hidden">
            We're a team of doers determined to change healthcare for the better
          </BodyLG>
        </div>
        <CarouselSection />

        <div className="tw-flex tw-flex-col tw-items-center tw-gap-[1.5em] tw-text-center">
          <BodyLG className="tw-my-0 tw-flex tw-flex-col tw-px-[1em] tw-text-white">
            Verse is backed by top healthcare and technology investors.
          </BodyLG>
          <img
            src="/landing_page_assets/investors.svg"
            alt="investors"
            className="tw-h-[22px] tw-w-full"
          />
        </div>
      </div>
    </div>
  );
};
